import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const isEditingEvaluacionesModalOpenStateSlice = createSlice({
	name: 'isEditingEvaluacionesModalOpenState',
	initialState,
	reducers: {
		setEditingEvaluacionesModalOpenState: (state, action) => {
			return action.payload;
		}
	}
});

export const { setEditingEvaluacionesModalOpenState } = isEditingEvaluacionesModalOpenStateSlice.actions;
export default isEditingEvaluacionesModalOpenStateSlice.reducer;
